/**
 * Przeniesienie zgłoszenia do systemu zgłoszeń GitHuba.
 *
 * Adres z wypełnionym tytułem i treścią zamiast wysyłki z serwera. Serwer nie
 * musi wtedy trzymać tokenu z prawem zapisu, nic nie wygasa i żadna awaria
 * GitHuba nie ma wpływu na przyjmowanie zgłoszeń — issue zakłada się
 * w przeglądarce, w której właścicielka i tak jest zalogowana.
 */

import type { Feedback } from '@/api/types'
import { FEEDBACK_KIND_LABELS } from '@/lib/dictionaries'

const REPOZYTORIUM = 'https://github.com/Homobonus/LegatoCrm'

/** Ile znaków opisu wchodzi do tytułu, zanim zostanie przycięty. */
const DLUGOSC_TYTULU = 70

function tytul(zgloszenie: Feedback): string {
  const pierwszaLinia = zgloszenie.message.split('\n')[0].trim()
  const skrot =
    pierwszaLinia.length > DLUGOSC_TYTULU
      ? `${pierwszaLinia.slice(0, DLUGOSC_TYTULU).trimEnd()}…`
      : pierwszaLinia
  return `${FEEDBACK_KIND_LABELS[zgloszenie.kind]}: ${skrot}`
}

function tresc(zgloszenie: Feedback): string {
  const wiersze = [
    zgloszenie.message,
    '',
    '---',
    `**Zgłaszający:** ${zgloszenie.reporter_name}`,
    `**Ekran:** ${zgloszenie.page_url ?? '—'}`,
    `**Wersja:** ${zgloszenie.app_version ?? '—'}`,
    `**Okno:** ${zgloszenie.viewport ?? '—'}`,
    `**Przeglądarka:** ${zgloszenie.user_agent ?? '—'}`,
  ]

  if (zgloszenie.console_errors) {
    wiersze.push('', '**Błędy z konsoli:**', '```', zgloszenie.console_errors, '```')
  }

  return wiersze.join('\n')
}

export function issueUrl(zgloszenie: Feedback): string {
  const parametry = new URLSearchParams({
    title: tytul(zgloszenie),
    body: tresc(zgloszenie),
    labels: zgloszenie.kind === 'BUG' ? 'bug' : 'enhancement',
  })
  return `${REPOZYTORIUM}/issues/new?${parametry.toString()}`
}
